import { useParams } from "react-router-dom";
import secondaryComponents from "../..";
import { useGetAllProductsList } from "../../../../hooks/api/queries";
import { useSellModeFilters } from "../../../../hooks/useSellModeFilters";
import ProductsList from "../ProductsList";
import ProductsGridList from "../ProductsGridList";
import { useCart } from "../../../../hooks/useCart";
import { useEffect } from "react";

export const SellModeProducts = ({ view, pricingType }) => {
  const { store_id } = useParams();
  const { search, filterByPage } = useSellModeFilters();
  const { addToCartForScanedproduct } = useCart({});
  const queries = (() => {
    let params = `?store_id=${store_id}&exclude_manage_mode_only_products=${true}`;
    for (const entry of search.entries()) {
      // if (entry[0] !== "is_scan")
      params = `${params}&${entry[0]}=${entry[1]}`;
    }

    return params;
  })();
  const {
    isLoading: isfetchingProducts,
    data,
    dataUpdatedAt,
  } = useGetAllProductsList({
    queries,
  });

  const products = data?.data;
  const metaDetails = data?.meta;
  const { handleAddToCart, cartItems, getCartItems, handleReduceCartItem } =
    useCart({});

  useEffect(() => {
    if (search.get("is_scan") === "true")
      if (products?.length > 0) addToCartForScanedproduct(products?.[0]);
  }, [dataUpdatedAt]);

  return (
    <>
      <secondaryComponents.LoaderHelper
        isLoading={isfetchingProducts}
        classNames={"mt-5"}
      >
        {view === "list" ? (
          <ProductsList
            products={products}
            handleAddToCart={handleAddToCart}
            cartItems={cartItems}
            getCartItems={getCartItems}
            handleReduceCartItem={handleReduceCartItem}
            pricingType={pricingType}
          />
        ) : (
          <ProductsGridList
            products={products}
            handleAddToCart={handleAddToCart}
            cartItems={cartItems}
            getCartItems={getCartItems}
            handleReduceCartItem={handleReduceCartItem}
            pricingType={pricingType}
          />
        )}
      </secondaryComponents.LoaderHelper>
      {/* pagination section */}
      {products?.length > 0 && (
        <div className="mt-auto mx-auto" style={{ width: "300px" }}>
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => filterByPage(value.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}
    </>
  );
};
